import { render, staticRenderFns } from "./IconFleet.vue?vue&type=template&id=bf0d627a"
import script from "./IconFleet.vue?vue&type=script&lang=js"
export * from "./IconFleet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports